import React, { useEffect, memo, useState } from "react";
import Service from "../services/service";
import Image from "./image";
import Link from 'next/link'

const Index = (props) => {

  const [data, setData] = useState(null); 
  const [page, setPage] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {

    const intersectionObserver = new IntersectionObserver(entries => {

      if (entries.some(entry => entry.isIntersecting)) {
        setPage((prevPage) => true);
      }
    })
    intersectionObserver.observe(document.querySelector('#myRecommendations'));
    return () => intersectionObserver.disconnect();
  }, []);


  useEffect(() => {

    if(page && !loaded){
      Service.get(`${Service.api}/recommendations/myrecommendations/${props.id}`)
      .then(resp => resp?.json())
      .then(resp => {
        setData(resp);
        setLoaded(true);
      })
      .catch((e) => console.log('erro ao consultar api quem eu indico -> ', e));
    }

    return () => {
        setData([]);
        setLoaded(false);
        setPage(false)
    }
  }, [page]);

  return (
      <div id="myRecommendations">
      {data && data.length > 0 &&
        <div className="py-5 mb-4 bg-light border-secondary border rounded-3">
          <div className="text-center">
            <h3 className="barlow fw-bold">Quem eu indico?</h3>
            <p className="text-muted">se eu não puder lhe atender, eu indico essas profissionais!</p>
          </div>
          <div className="container">
            <ul className="list-unstyled d-flex justify-content-center gap-2 text-center">
            {data?.map((item, index) => {
              return (<li key={item._id}><Link href={`/diarista/${item.recommendUserId._id}`}><Image classNameFigure="" className="rounded-circle img-thumbnail" caption={item.recommendUserId.nome} alt={item.recommendUserId.nome} src={item.recommendUserId.imageURL} /></Link></li>)
            })}
            </ul>
          </div>
        </div>
      }
      </div>
  );
};

export default memo(Index);
